import { render, staticRenderFns } from "./SingGenealogy.vue?vue&type=template&id=2344f3a3&scoped=true"
import script from "./SingGenealogy.vue?vue&type=script&lang=js"
export * from "./SingGenealogy.vue?vue&type=script&lang=js"
import style0 from "./SingGenealogy.vue?vue&type=style&index=0&id=2344f3a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2344f3a3",
  null
  
)

export default component.exports